module.exports = __webpack_public_path__ + "img/coupon_five.de81d541.webp";